<template>
	<ul :class="`no-style ${rootGroup ? 'pl-0' : ''}`">
		<li class="mb-4" v-if="messages.length > messagesSliceSize">
			<h5 class="text-center">
				{{ $t("validation_error.more_than_validation_messages", { length: messages.length, sliceLength: messagesSliceSize }) }}
			</h5>
		</li>

		<li v-for="message in messagesSlice" :key="`validation-message-${message.index}${message.field}`">
			<p v-if="message.field" class="font-weight-bold">
				{{ translateField({ field: message.field }) }}
			</p>

			<ul v-if="message.constraints" class="no-style">
				<li v-for="{ constraint, parameters } in message.constraints" :key="`validation-message-${message.index}${message.field}-${constraint}`">
					{{
						parameters
							? $t(`validation_error.constraints.${constraint}Params`, {
									field: message.field,
									...CommonUtil.flattenObject({ obj: parameters, prefix: "parameters" })
							  })
							: $t(`validation_error.constraints.${constraint}`)
					}}
				</li>
			</ul>

			<h3 v-if="message.index !== undefined">
				{{ $t(`validation_error.at_index`, { index: message.index }) }}
			</h3>

			<ValidationGroup v-if="message.children" :messages="message.children" />
		</li>
	</ul>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { ApiValidationMessage } from "@/models/internal.model";
import { CommonUtil } from "@/utils/common.util";

export default Vue.extend({
	name: "ValidationGroup",
	props: {
		messages: {
			type: Array as PropType<Array<ApiValidationMessage>>,
			default: () => []
		},
		rootGroup: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		CommonUtil,
		messagesSliceSize: 10,
		messagesSlice: [] as ApiValidationMessage[]
	}),
	mounted() {
		this.sliceMessages();
	},
	watch: {
		messages() {
			this.sliceMessages();
		}
	},
	methods: {
		sliceMessages() {
			if (this.messages) {
				// show only 10 messages
				this.messagesSlice = this.messages.slice(0, this.messagesSliceSize);
			}
		},
		translateField({ field }: { field: string }): string {
			const prefix = "validation_error.fields";
			const translation = this.$t(`${prefix}.${field}`).toString();
			return translation.startsWith(prefix) ? field : translation;
		}
	}
});
</script>
